// Mirrors the Postgres enums defined in supabase/migrations/0001_init.sql.
// Keep these in sync by hand — they're small and rarely change; regenerating
// database.types.ts (via `pnpm gen:types`) is the source of truth to diff against.

export const ORDER_STATUSES = ["new", "in_progress", "done", "rejected"] as const;
export type OrderStatus = (typeof ORDER_STATUSES)[number];

export const REJECT_REASONS = ["price", "not_relevant"] as const;
export type RejectReason = (typeof REJECT_REASONS)[number];

export const ORDER_SOURCES = ["site", "phone", "instagram", "telegram"] as const;
export type OrderSource = (typeof ORDER_SOURCES)[number];

export const WHEEL_SIZES = ["R18", "R19", "R20", "R21", "R22", "R23"] as const;
export type WheelSize = (typeof WHEEL_SIZES)[number];

export const PRODUCT_LINES = ["wheels", "steering_wheels"] as const;
export type ProductLine = (typeof PRODUCT_LINES)[number];

export const CAR_YEAR_MIN = 2000;
export const CAR_YEAR_MAX = 2028;

/** Descending list for the car-year dropdown, 2028 → 2000, per AGENTS.md §6.2. */
export const CAR_YEARS: number[] = Array.from(
  { length: CAR_YEAR_MAX - CAR_YEAR_MIN + 1 },
  (_, i) => CAR_YEAR_MAX - i,
);

export const WORKING_HOURS_START = "09:00";
export const WORKING_HOURS_END = "19:00";

export const REMINDER_NOTE_PRESETS = [
  "Передзвонити клієнту",
  "Забрати замовлення",
  "Запитати, що вирішив",
] as const;
